var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Costo Ponderado")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":""},model:{value:(_vm.weighted_cost),callback:function ($$v) {_vm.weighted_cost=$$v},expression:"weighted_cost"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d5261b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/items/WeightedAverageCost.vue
// module id = 1fy/
// module chunks = 0